module.exports = __webpack_public_path__ + "img/user.8c06c22e.png";